import { render, staticRenderFns } from "./ServiceChange.vue?vue&type=template&id=8fbe34ce&scoped=true&"
import script from "./ServiceChange.vue?vue&type=script&lang=js&"
export * from "./ServiceChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbe34ce",
  null
  
)

export default component.exports